   import React, { useContext, useEffect, useState } from "react";
   import { Box, CardContent } from "@mui/material";
   import HeroBanner from "../components/HeroBanner";
   import SearchExercise from "../components/SearchExercise";
   import Exercises from "../components/Exercises";
   import { useLocation, useNavigate } from "react-router-dom";
   import { Update } from "../App";
   
   const Explore = () => {
     const { setDisplayAppBar } = useContext(Update);
     const location = useLocation();
     const navigate = useNavigate();
     useEffect(() => {
       if (location.pathname === "/explore") {
         setDisplayAppBar("block");
       }
     }, [location.pathname]);
     const [bodyPart, setBodyPart] = useState("all");
     const [exercises, setExercises] = useState([]);
     return (
       <Box>
         <HeroBanner />
         <SearchExercise
           setExercises={setExercises}
           bodyPart={bodyPart}
           setBodyPart={setBodyPart}
         />
           {" "}
           <Exercises
             exercises={exercises}
             setExercises={setExercises}
             bodyPart={bodyPart}
           />
       </Box>
     );
   };
   
   export default Explore;
   